import React from 'react';
import { CheckIcon } from 'lucide-react';
import { OrderStatus } from '../context/StoreContext';
interface OrderTrackerProps {
  status: OrderStatus;
  date: string;
  deliveryDate?: string;
}
export function OrderTracker({
  status,
  date,
  deliveryDate
}: OrderTrackerProps) {
  const steps = ['Placed', 'Confirmed', 'Shipped', 'Delivered'];
  if (status === 'Cancelled') {
    return <div className="bg-red-50 border border-red-100 rounded-xl p-6 text-center" data-id="element-218">
        <div className="w-12 h-12 bg-red-100 text-red-600 rounded-full flex items-center justify-center mx-auto mb-3" data-id="element-219">
          <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-220">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" data-id="element-221" />
          </svg>
        </div>
        <h3 className="text-lg font-bold text-red-800 mb-1" data-id="element-222">Order Cancelled</h3>
        <p className="text-sm text-red-600" data-id="element-223">This order has been cancelled.</p>
      </div>;
  }
  const currentStepIndex = steps.indexOf(status);
  return <div className="py-6" data-id="element-224">
      <div className="relative" data-id="element-225">
        {/* Progress Bar Background */}
        <div className="absolute top-5 left-6 right-6 h-1 bg-slate-200 rounded-full" data-id="element-226"></div>

        {/* Active Progress Bar */}
        <div className="absolute top-5 left-6 h-1 bg-green-500 rounded-full transition-all duration-500" style={{
        width: `calc(${currentStepIndex / (steps.length - 1) * 100}% - 24px)`
      }} data-id="element-227"></div>

        {/* Steps */}
        <div className="relative flex justify-between" data-id="element-228">
          {steps.map((step, index) => {
          const isCompleted = index <= currentStepIndex;
          const isCurrent = index === currentStepIndex;
          return <div key={step} className="flex flex-col items-center w-24" data-id="element-229">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center z-10 transition-colors duration-300 border-2 ${isCompleted ? 'bg-green-500 border-green-500 text-white' : 'bg-white border-slate-300 text-slate-400'} ${isCurrent ? 'ring-4 ring-green-100' : ''}`} data-id="element-230">
                  {isCompleted ? <CheckIcon className="w-5 h-5" data-id="element-231" /> : <span className="text-sm font-medium" data-id="element-232">{index + 1}</span>}
                </div>
                <div className="mt-3 text-center" data-id="element-233">
                  <p className={`text-sm font-medium ${isCompleted ? 'text-slate-900' : 'text-slate-500'}`} data-id="element-234">
                    {step}
                  </p>
                  {index === 0 && <p className="text-xs text-slate-500 mt-1" data-id="element-235">
                      {new Date(date).toLocaleDateString('en-IN', {
                  month: 'short',
                  day: 'numeric'
                })}
                    </p>}
                  {index === 3 && deliveryDate && <p className="text-xs text-slate-500 mt-1" data-id="element-236">
                      Est.{' '}
                      {new Date(deliveryDate).toLocaleDateString('en-IN', {
                  month: 'short',
                  day: 'numeric'
                })}
                    </p>}
                </div>
              </div>;
        })}
        </div>
      </div>
    </div>;
}